import {view, Icon} from '@sail/ui';
import type {VariantStyles} from 'src/v2/components/anyCrypto/progress/progressVariant';

type Props = {
  statusIconVariant: VariantStyles;
};

export const ProgressStatusIcon = ({statusIconVariant}: Props) => (
  <view.div
    css={{
      stack: 'x',
      alignX: 'center',
      alignY: 'center',
      width: 'xxlarge',
      height: 'xxlarge',
      borderRadius: '50%',
      backgroundColor: statusIconVariant.iconBackground,
    }}
  >
    <Icon
      icon={statusIconVariant.icon}
      css={{
        width: statusIconVariant.iconSize,
        height: statusIconVariant.iconSize,
        color: statusIconVariant.iconColor,
      }}
    />
  </view.div>
);
